module.exports = __webpack_public_path__ + "static/media/testimonials-1.b6d17018.jpg";